export default __webpack_public_path__ + "static/media/FileMove.2ff61f72.svg";